import {Component, OnInit} from "@angular/core";
import {Auth2Service} from "../../../../../services/auth2.service";
import {ApiService} from "../../../../../services/api.service";
import {UserService} from "../../../services/users.service";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";
import {SearchService} from "../../../../search-nonprofits-donors/services/search.service";
import {SearchGrantsService} from "../../../../search-grants/services/search-grants.service";
import {SearchGrantsFilterDto} from "../../../../../models/search-grants-filter-dto";
import {LoggedInPageBaseComponent} from "../../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-saved-searches-grant-create-edit',
  templateUrl: './saved-searches-grant-create-edit.component.html',
  styleUrls: ['./saved-searches-grant-create-edit.component.scss'],
  standalone: false
})
export class SavedSearchesGrantCreateEditComponent extends LoggedInPageBaseComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Your Saved Searches', path: 'app/users/dashboard/saved-searches/all'},
    { label: 'Create / Edit Grant Saved Search'}
  ];

  //DONOR_SEARCH default, but there is also GRANT_SEARCH and NONPROFIT_SEARCH
  searchTypeName = "GRANT_SEARCH";

  currentSavedSearchDto: any = null;

  searchTypeNameMap: any = {};
  searchTypeNameLoadedFlag: boolean = false;
  causesLoadedFlag: boolean = false;
  taxYearLoadedFlag: boolean = false;

  savedSearchLoadedFlag: boolean = false;

  username: string = '';
  impersonatedEmail: any = null;
  consultantRoleName: any = null;
  readOnly: boolean = false;

  savedGrantSearchName: string = '';
  grant_recipientNames: string[] = [];
  grant_eins: string[] = []
  grant_states: string[] = [];
  grant_cities: string[] = [];
  grant_citiesWithout: string[] = [];
  grant_grantAmtMin: number = -1;
  grant_grantAmtMinStr: string = '';
  grant_grantAmtMax: number = -1;
  grant_grantAmtMaxStr: string = '';
  grant_taxYear: number = -1;
  grant_cause: string = '';

  grant_statesList: any[] = [];

  grant_taxYearsRadioButtons: any[] = [
    {
      "taxYear": 2025,
      "checked": false
    }, {
      "taxYear": 2024,
      "checked": true
    },{
      "taxYear": 2023,
      "checked": false
    },{
      "taxYear": 2022,
      "checked": false
    },{
      "taxYear": 2021,
      "checked": false
    },{
      "taxYear": 2020,
      "checked": false
    },{
      "taxYear": 2019,
      "checked": false
    },{
      "taxYear": 2018,
      "checked": false
    }
  ];
  grant_taxYearsButton: any = true;

  grant_causesRadioButtons: any[] = [];
  grant_causesButton: any = false;

  causeDropdownList: any[] = [];
  causeGivingInterestsDropdownList: any[] = [];

  grant_causeGivingInterestsSetObj: any = {};
  grant_givingInterestsSetObj: any = {};
  grant_givingInterestsWithoutSetObj: any = {};

  grant_causeGivingInterestsList: string[] = [];
  grant_causeGivingInterestsWithoutList: string[] = [];

  logicalOperatorAnd: boolean = false;
  logicalOperatorOr: boolean = true;

  recipientNameAscRadioButton: boolean = false;
  recipientNameDescRadioButton: boolean = false;
  sortByRecipientNameAscId: number = 0

  cityAscRadioButton: boolean = false;
  cityDescRadioButton: boolean = false;
  sortByCityAscId: number = 0;

  stateAscRadioButton: boolean = false;
  stateDescRadioButton: boolean = false;
  sortByStateAscId: number = 0;

  grantAmountAscRadioButton: boolean = false;
  grantAmountDescRadioButton: boolean = false;
  sortByGrantAmtAscId: number = 0;

  browserUrl: string = '';

  recipientNamesAutocomplete: any[] = [];
  citiesAutocomplete: any[] = [];

  //Needs pop up for SavedSearch Limit on creation
  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private userService : UserService,
              private searchService: SearchService, private searchGrantsService: SearchGrantsService,
              private routerChild: Router, private route: ActivatedRoute, private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy Create or Edit Grant Saved Search");
  }

  populateGrantsCities(): void {
    // @ts-ignore
    let grantCitiesCacheExpTimeStr: string = localStorage.getItem('grantCitiesCacheExpTime');
    if (!grantCitiesCacheExpTimeStr) {
      //expire the cached search
      localStorage.removeItem('grantCitiesCache');
    } else {
      let grantExpTime: number = parseInt(grantCitiesCacheExpTimeStr);
      let now = Date.now();
      if (now >= grantExpTime) {
        //expire the cached search
        localStorage.removeItem('grantCitiesCache');
      }
    }
    const grantCitiesCacheJsonString = localStorage.getItem('grantCitiesCache');
    if (!grantCitiesCacheJsonString) {
      this.searchGrantsService.getGrantsCities(this.username).subscribe((result: any) => {
        if (result && result.body) {
          let i: number = 0;
          while (i < result.body.size) {
            this.citiesAutocomplete.push(result.body.citiesStates[i]);
            i = i + 1;
          }
          let expirationTimestamp: number = Date.now() + 1000*3600*8;
          localStorage.setItem('grantCitiesCacheExpTime', expirationTimestamp.toString());
          localStorage.setItem('grantCitiesCache', JSON.stringify(this.citiesAutocomplete));
        }
      }, (error: HttpErrorResponse) => {
        this.pageErrorMessages.push({
          field: 'Search Grants Error',
          detail: 'Failed to pull Grants Recipients cities.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
      });
    } else {
      this.citiesAutocomplete = JSON.parse(grantCitiesCacheJsonString);
    }
  }

  populateGrantsRecipientNames(): void {
    this.searchGrantsService.getGrantsRecipientNames(this.username).subscribe((result: any) => {
      if (result && result.body) {
        let i: number = 0;
        while (i < result.body.length) {
          this.recipientNamesAutocomplete.push(result.body[i]);
          i = i + 1;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.pageErrorMessages.push({
        field: 'Search Grants Error',
        detail: 'Failed to pull Grants Recipients names.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    })
  }

  ngOnInit() {
    // @ts-ignore
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    this.consultantRoleName = this.auth2ServiceChild.getConsultantRoleName();
    this.browserUrl = window.location.href;
    this.readOnly = this.apiService.calculateReadOnly(this.browserUrl, this.impersonatedEmail, this.consultantRoleName);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    if (this.browserUrl.includes('view')) {
      this.titleService.setTitle("Scalanthropy View Grant Saved Search");
      this.breadCrumbs[4] = { label: 'View Grant Saved Search'};
    }
    this.searchTypeNameLoadedFlag = false;
    //this.affiliationCodeIdsLoadedFlag = false;
    //this.deductabilityCodeIdsLoadedFlag = false;
    this.causesLoadedFlag = false;
    this.taxYearLoadedFlag = true;

    this.savedSearchLoadedFlag = false;

    this.loadSearchTypeNameMap();
    if(this.browserUrl.includes('view')) {
      const currentSavedSearchId = this.route.snapshot.paramMap.get('savedSearchId');
      // @ts-ignore
      this.userService.getSavedSearch(currentSavedSearchId, this.username, this.impersonatedEmail).subscribe(
        (result: any) => {
          if (result && result.body) {
            this.currentSavedSearchDto = result.body;
            //Distribute the saved search parameters to the radioboxes,checkboxes, and textboxes
            this.loadSavedGrantSearchParams();
            this.savedSearchLoadedFlag = true;
          }
          return;
        }, (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          this.pageErrorMessages.push({
            field: 'Saved Search API Failure',
            detail: 'Failed to download the savedSearchId: ' + currentSavedSearchId,
            severity: 'error'
          });
          this.showErrorMessagesToUser();
          return;
        }
      );
    } else {
      this.populateUSAStates();
      this.populateGrantsCities();
      //this.populateGrantsRecipientNames();
      this.populateCausesRadioButtons();
      //this.populateTaxYearsRadioButtons();
      this.populateCauseGivingInterestsDropdown();
      //retries
      let retries_limit = 4;
      let count = 0;
      while (count < retries_limit) {
        setTimeout(() => {
          if (this.savedSearchLoadedFlag) {
            return;
          }

          if (this.searchTypeNameLoadedFlag && this.causesLoadedFlag && this.taxYearLoadedFlag) {
            this.browserUrl = window.location.href;
            if (this.browserUrl.includes('edit') || this.browserUrl.includes('view')) {
              //extract the id from the browser url
              const currentSavedSearchId = this.route.snapshot.paramMap.get('savedSearchId');
              //load the saved search from the database
              // @ts-ignore
              this.userService.getSavedSearch(currentSavedSearchId, this.username).subscribe(
                (result: any) => {
                  if (result && result.body) {
                    this.currentSavedSearchDto = result.body;
                    //Distribute the saved search parameters to the radioboxes,checkboxes, and textboxes
                    this.loadSavedGrantSearchParams();
                    this.savedSearchLoadedFlag = true;
                  }
                }, (err: HttpErrorResponse) => {
                  this.pageErrorMessages.push({
                    field: 'Grant Saved Search API Failure',
                    detail: 'Failed to download the savedSearchId: ' + currentSavedSearchId,
                    severity: 'error'
                  });
                  this.showPageErrorMessagesToUser();
                }
              );
            }
          }
        }, 8000);
        count = count + 1;
      }
      ;
    }
  }

  loadSavedGrantSearchParams(): void {
    if (this.currentSavedSearchDto.savedSearchName) {
      this.savedGrantSearchName = this.currentSavedSearchDto.savedSearchName;
    }
    if (this.currentSavedSearchDto.savedSearchJson) {
      let grantSearchJson: any = JSON.parse(this.currentSavedSearchDto.savedSearchJson);
      if (grantSearchJson['recipientNames']) {
        this.grant_recipientNames = grantSearchJson['recipientNames'];
        const grantNameInputEl = document.getElementById('grant-search-grant-names-text-id');
        if (this.grant_recipientNames.length > 0) {
          // @ts-ignore
          grantNameInputEl.value = this.grant_recipientNames.join(',');
        } else {
          // @ts-ignore
          grantNameInputEl.value = '';
        }
      }
      if (grantSearchJson['state']) {
        this.grant_states.push(grantSearchJson['state']);
        const usaStateDropdownEl = document.getElementById('usa-dropdown-list-id');
        // @ts-ignore
        usaStateDropdownEl.value = this.grant_states[0];
      }
      if (grantSearchJson['states']) {
        this.grant_states.push(grantSearchJson['states'][0]);
        if (!this.readOnly) {
          const usaStateDropdownEl = document.getElementById('usa-dropdown-list-id');
          // @ts-ignore
          usaStateDropdownEl.value = this.grant_states[0];
        } else {
          const usaStateDropdownEl = document.getElementById('usa-state-text-list-id');
          // @ts-ignore
          usaStateDropdownEl.value = this.grant_states[0];
        }
      }
      if (grantSearchJson['eins']) {
        this.grant_eins = grantSearchJson['eins'];
        const grantEinsInputEl = document.getElementById('eins-text-id');
        if (this.grant_eins.length > 0) {
          // @ts-ignore
          grantEinsInputEl.value = this.grant_eins.join(',');
        } else {
          // @ts-ignore
          grantEinsInputEl.value = '';
        }
      }
      if (grantSearchJson['cities']) {
        this.grant_cities = grantSearchJson['cities'];
        const grantCitiesInputEl = document.getElementById('cities-text-id');
        if (this.grant_cities.length > 0) {
          // @ts-ignore
          grantCitiesInputEl.value = this.grant_cities.join(',');
        } else {
          // @ts-ignore
          grantCitiesInputEl.value = '';
        }
      }
      if (grantSearchJson['grantAmtMin']) {
        if (grantSearchJson['grantAmtMin'] == -1) {
          this.grant_grantAmtMinStr = ''
        } else {
          this.grant_grantAmtMinStr = grantSearchJson['grantAmtMin'];
        }
      }
      if (grantSearchJson['grantAmtMax']) {
        if (grantSearchJson['grantAmtMax'] == -1) {
          this.grant_grantAmtMaxStr = ''
        } else {
          this.grant_grantAmtMaxStr = grantSearchJson['grantAmtMax'];
        }
      }

      if (grantSearchJson['taxYear']) {
        let i: number = 0;
        let taxYearLength: number =  this.grant_taxYearsRadioButtons.length;
        while (i < taxYearLength) {
          this.grant_taxYearsRadioButtons[i].checked = false;
          i = i + 1;
        }
        i = 0;
        while (i < taxYearLength) {
          if (this.grant_taxYearsRadioButtons[i].taxYear === grantSearchJson['taxYear']) {
            this.grant_taxYearsRadioButtons[i].checked = true;
            break;
          }
          i = i + 1;
        }
      }

      this.grant_causeGivingInterestsList = [];
      if (grantSearchJson['causeGivingInterests'] && grantSearchJson['causeGivingInterests'].length > 0) {
        for (const causeGivingInterest of grantSearchJson['causeGivingInterests']) {
          this.grant_causeGivingInterestsList.push(causeGivingInterest);
        }
      }

      this.grant_causeGivingInterestsWithoutList = [];
      /*
      if (grantSearchJson['causeGivingInterestsWithout'] && grantSearchJson['causeGivingInterestsWithout'].length > 0) {
        for (const causeGivingInterest of grantSearchJson['causeGivingInterestsWithout']) {
          this.grant_causeGivingInterestsWithoutList.push(causeGivingInterest);
        }
      }*/

      this.recipientNameAscRadioButton = false;
      this.recipientNameDescRadioButton = false;
      if (grantSearchJson['sortByRecipientNameAsc']) {
        if (grantSearchJson['sortByRecipientNameAsc'] == 1) {
          this.recipientNameAscRadioButton = true;
        } else if (grantSearchJson['sortByRecipientNameAsc'] == 2) {
          this.recipientNameDescRadioButton = true;
        }
      }

      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      if (grantSearchJson['sortByCityAsc']) {
        if (grantSearchJson['sortByCityAsc'] == 1) {
          this.cityAscRadioButton = true;
        } else if (grantSearchJson['sortByCityAsc'] == 2) {
          this.cityDescRadioButton = true;
        }
      }

      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      if (grantSearchJson['sortByStateAsc']) {
        if (grantSearchJson['sortByStateAsc'] == 1) {
          this.stateAscRadioButton = true;
        } else if (grantSearchJson['sortByStateAsc'] == 2) {
          this.stateDescRadioButton = true;
        }
      }

      this.grantAmountAscRadioButton = false;
      this.grantAmountDescRadioButton = false;
      if (grantSearchJson['sortByGrantAmtAsc']) {
        if (grantSearchJson['sortByGrantAmtAsc'] == 1) {
          this.grantAmountAscRadioButton = true;
        } else if (grantSearchJson['sortByGrantAmtAsc'] == 2) {
          this.grantAmountDescRadioButton = true;
        }
      }
    }
  }

  loadSearchTypeNameMap(): void {
    this.searchService.getSearchTypeNamesDropdown(this.username)
      .subscribe((result: any) => {
        if (result && result.body) {
          for (const searchTypeNameTemp of result.body){
            this.searchTypeNameMap[searchTypeNameTemp.searchTypeName] = searchTypeNameTemp.searchTypeId;
          }
          this.searchTypeNameLoadedFlag = true;
        }
        return;
    }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Grant Saved Search API Failure',
          detail: 'Failed to pull the Search Type Names....',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        this.searchTypeNameLoadedFlag = false;
        return;
      });
    this.searchTypeNameLoadedFlag = false;
    return;
  }

  resetFilters() {
    const grantNameInputEl = document.getElementById('grant-search-grant-names-text-id');
    // @ts-ignore
    grantNameInputEl.value = '';
    const einsInputEl = document.getElementById('eins-text-id');
    // @ts-ignore
    einsInputEl.value = '';
    const grantCityInputEl = document.getElementById('cities-text-id');
    // @ts-ignore
    grantCityInputEl.value = '';
    const usaStateDropdownEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    usaStateDropdownEl.value = '';
    const grantAmtMinInputEl = document.getElementById('grant-grant-amt-min-text-id');
    // @ts-ignore
    grantAmtMinInputEl.value = '';
    const grantAmtMaxInputEl = document.getElementById('grant-grant-amt-max-text-id');
    // @ts-ignore
    grantAmtMaxInputEl.value = '';

    const causeCategorySel = document.getElementById("cause-category-dropdown-list-id");
    // @ts-ignore
    causeCategorySel.value = '';

    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    causeGivingInterestEl.value = '';
    this.grant_recipientNames = [];
    this.grant_eins = [];
    this.grant_cities = [];
    this.grant_citiesWithout = [];
    this.grant_grantAmtMinStr = '';
    this.grant_grantAmtMaxStr = '';

    for (const grant_taxYearsRadioButtonTemp of this.grant_taxYearsRadioButtons) {
      grant_taxYearsRadioButtonTemp.checked = false;
    }
    //default to latest tax year
    this.grant_taxYearsRadioButtons[1].checked = true

    for(const grant_causesRadioButtonTemp of this.grant_causesRadioButtons) {
      grant_causesRadioButtonTemp.checked = false;
    }

    this.grant_givingInterestsSetObj = {};
    this.grant_givingInterestsWithoutSetObj = {};
    this.grant_causeGivingInterestsList = [];
    this.grant_causeGivingInterestsWithoutList = [];

    this.recipientNameAscRadioButton = false;
    this.recipientNameDescRadioButton = false;
    this.sortByRecipientNameAscId = 0

    this.cityAscRadioButton = false;
    this.cityDescRadioButton = false;
    this.sortByCityAscId = 0;

    this.stateAscRadioButton = false;
    this.stateDescRadioButton = false;
    this.sortByStateAscId = 0;

    this.grantAmountAscRadioButton = false;
    this.grantAmountDescRadioButton = false;
    this.sortByGrantAmtAscId = 0;
  }

  populateTaxYearsRadioButtons(): void {
    this.searchGrantsService.getTaxYearsDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.grant_taxYearsRadioButtons = result.body;
        if (this.grant_taxYearsRadioButtons.length > 0) {
          // Tax Years are sorted in descending order, most recent tax year is selected by default in
          this.grant_taxYearsRadioButtons[0]['checked'] = true;
        }
        this.taxYearLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.taxYearLoadedFlag = false;
      return;
    });
    this.taxYearLoadedFlag = false;
    return;
  }

  toggleTaxYearsFilter(): any {
    this.grant_taxYearsButton = !this.grant_taxYearsButton;
  }

  trackTaxYears(idValue:number): void {
    //Clear Radio Buttons
    for (const radioButton of this.grant_taxYearsRadioButtons) {
      radioButton.checked = false;
    }
    const taxYearsEl = document.getElementById('flexRadioGrantTaxYears-' + idValue);
    // @ts-ignore
    this.grant_taxYearsRadioButtons[idValue]['checked'] = taxYearsEl.checked;
  }

  populateUSAStates(): void {
    this.grant_statesList = [];
    this.searchService.getUSAStatesDropdown().subscribe((result: any) => {
      if (result && result.body) {
        let i: number = 0;
        while (i < result.body.length) {
          this.grant_statesList.push(result.body[i]);
          i = i + 1;
        }
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Grant Saved Search API Failure',
        detail: 'Failed to pull the USA States...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      return;
    })
    return;
  }

  populateCausesRadioButtons(): void {
    this.searchService.getCausesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.causeDropdownList = result.body;
        this.causesLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Grant Saved Search API Failure',
        detail: 'Failed to pull the Causes Categories...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.causesLoadedFlag = false;
      return;
    });
    this.causesLoadedFlag = false;
    return;
  }

  updateCauseGivingInterestsDropdown(): boolean {
    var causeCategorySel = document.getElementById("cause-category-dropdown-list-id");
    // @ts-ignore
    let causeCategorySelVal = causeCategorySel.value;
    if (causeCategorySel) {
      if (this.grant_causeGivingInterestsSetObj[causeCategorySelVal]) {
        this.causeGivingInterestsDropdownList = this.grant_causeGivingInterestsSetObj[causeCategorySelVal];
        this.causeGivingInterestsDropdownList = this.causeGivingInterestsDropdownList.concat(
          [{givingInterestDisplayName: 'All Other Cause Category Giving Interests', givingInterestName: 'ALL_OTHER_CAUSE_CATEGORY_GIVING_INTERESTS' }], this.grant_causeGivingInterestsSetObj['ALL'])
      } else {
        this.causeGivingInterestsDropdownList = this.grant_causeGivingInterestsSetObj["ALL"];
      }
    }
    return true;
  }

  populateCauseGivingInterestsDropdown(): void {
    this.searchService.getAllGivingInterestsDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.grant_causeGivingInterestsSetObj = result.body;
        this.causeGivingInterestsDropdownList = this.grant_causeGivingInterestsSetObj["ALL"];
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Grant Saved Search API Failure',
        detail: 'Failed to pull the Causes Giving Interests...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  trackLogicalExpression(logicalOperator: string): void {
    if (logicalOperator == 'AND') {
      this.logicalOperatorAnd = true;
      this.logicalOperatorOr = false;
    } else if (logicalOperator == 'OR') {
      this.logicalOperatorAnd = false;
      this.logicalOperatorOr = true;
    } else {
      this.logicalOperatorAnd = false;
      this.logicalOperatorOr = true;
    }
  }
  addCauseGivingInterestFilter(addFlag: boolean): void {
    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    const causeGivingInterestSelected = causeGivingInterestEl.value;
    if (causeGivingInterestSelected) {
      if (addFlag) {
        this.grant_givingInterestsSetObj[causeGivingInterestSelected] = 0;
        this.recalculateListOfGivingInterests();
      } else {
        this.grant_givingInterestsWithoutSetObj[causeGivingInterestSelected] = 0;
        this.recalculateListOfGivingInterestsWithout();
      }
    }
  }

  recalculateListOfGivingInterests2(causingGivingInterest: string): void {
    if (this.grant_causeGivingInterestsList.length > 0) {
      if (this.logicalOperatorAnd && !this.logicalOperatorOr) {
        this.grant_causeGivingInterestsList.push("AND");
      } else if (!this.logicalOperatorAnd && this.logicalOperatorOr) {
        this.grant_causeGivingInterestsList.push("OR");
      } else {
        this.grant_causeGivingInterestsList.push("OR");
      }
    }
    this.grant_causeGivingInterestsList.push(causingGivingInterest);
  }

  recalculateListOfGivingInterestsWithout2(causingGivingInterest: string): void {
    this.grant_causeGivingInterestsWithoutList.push(causingGivingInterest);
  }

  addCauseGivingInterestFilter2(addFlag: boolean): void {
    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    const causeGivingInterestSelected = causeGivingInterestEl.value;
    if (causeGivingInterestSelected) {
      if ('ALL_OTHER_CAUSE_CATEGORY_GIVING_INTERESTS' == causeGivingInterestSelected) {
        return;
      }
      if (addFlag) {
        this.recalculateListOfGivingInterests2(causeGivingInterestSelected);
      } else {
        this.recalculateListOfGivingInterestsWithout2(causeGivingInterestSelected);
      }
    }
  }

  onDeleteGivingInterest(row: string): void {
    const index = this.grant_causeGivingInterestsList.indexOf(row);
    const size = this.grant_causeGivingInterestsList.length;
    const causeGivingInterestsListTemp: string[] = []
    if (size == 1) {
      this.grant_causeGivingInterestsList = [];
      return;
    }
    if (index == (size - 1) ) {
      let excludedSize: number = size - 2;
      let i = 0;
      while (i < excludedSize) {
        causeGivingInterestsListTemp.push(this.grant_causeGivingInterestsList[i]);
        i = i + 1;
      }
      this.grant_causeGivingInterestsList = causeGivingInterestsListTemp;
      return;
    }
    let i = 0;
    while (i < size) {
      if (index == 0 && i == 0 && size > 1) {
        //skip elements 0 and 1
        i = i + 2;
        causeGivingInterestsListTemp.push(this.grant_causeGivingInterestsList[i]);
      } else if (index == i && size > 1) {
        //skip elements i and i + 1
        i = i + 2;
        causeGivingInterestsListTemp.push(this.grant_causeGivingInterestsList[i]);
      } else {
        causeGivingInterestsListTemp.push(this.grant_causeGivingInterestsList[i]);
      }
      i = i + 1;
    }
    this.grant_causeGivingInterestsList = causeGivingInterestsListTemp;
  }

  onDeleteGivingInterestWithout(row: string): void {
    const index = this.grant_causeGivingInterestsWithoutList.indexOf(row);
    const size = this.grant_causeGivingInterestsWithoutList.length;
    const causeGivingInterestsWithoutListTemp: string[] = [];
    let i = 0;
    while (i < size) {
      if (i != index) {
        causeGivingInterestsWithoutListTemp.push(this.grant_causeGivingInterestsWithoutList[i]);
      }
      i = i + 1;
    }
    this.grant_causeGivingInterestsWithoutList = causeGivingInterestsWithoutListTemp;
  }


  recalculateListOfGivingInterests(): void {
    this.grant_causeGivingInterestsList = [];
    for (const givingInterest in this.grant_givingInterestsSetObj) {
      this.grant_causeGivingInterestsList.push(givingInterest);
    }
  }

  recalculateListOfGivingInterestsWithout(): void {
    this.grant_causeGivingInterestsWithoutList = [];
    for (const givingInterestWithout in this.grant_givingInterestsWithoutSetObj) {
      this.grant_causeGivingInterestsWithoutList.push(givingInterestWithout);
    }
  }

  recalculateObjOfGivingInterests(): void {
    this.grant_givingInterestsSetObj = {};
    for (const givingInterest in this.grant_causeGivingInterestsList) {
      this.grant_givingInterestsSetObj[givingInterest] = 0;
    }
  }
  recalculateObjOfGivingInterestsWithout(): void {
    this.grant_givingInterestsWithoutSetObj = {};
    for (const givingInterestWithout in this.grant_causeGivingInterestsWithoutList) {
      this.grant_givingInterestsWithoutSetObj[givingInterestWithout] = 0;
    }
  }

  deleteGivingInterestChip2(event: Event): void {
    // @ts-ignore
    //delete this.givingInterestsSetObj[event.target.value];
    this.recalculateObjOfGivingInterests();
  }

  deleteGivingInterestWithoutChip2(event: Event): void {
    // @ts-ignore
    //delete this.givingInterestsWithoutSetObj[event.target.value];
    this.recalculateObjOfGivingInterestsWithout();
  }

  deleteGivingInterestChip3(row: any): void {
    let newList: any[] = [];
    for (const rowTemp of this.grant_causeGivingInterestsList) {
      if (rowTemp != row) {
        newList.push(rowTemp);
      }
    }
    this.grant_causeGivingInterestsList = newList;

    this.recalculateObjOfGivingInterests();
  }

  deleteGivingInterestWithoutChip3(row: any): void {
    let newList: any[] = [];
    for (const rowTemp of this.grant_causeGivingInterestsWithoutList) {
      if (rowTemp != row) {
        newList.push(rowTemp);
      }
    }
    this.grant_causeGivingInterestsWithoutList = newList;

    this.recalculateObjOfGivingInterestsWithout();
  }

  onCancel() {
    this.routerChild.navigateByUrl('app/users/dashboard/saved-searches/all');
  }

  executeSearch(browserUrl: string, savedSearchName: string, filter: string, username: string, saveAndApplyFlag: boolean): void {
    if (browserUrl.includes('create')) {
      const savedSearchDto: any = {
        savedSearchId: -1,
        userId: -1,
        savedSearchName: savedSearchName,
        searchTypeDto: {
          searchTypeId: this.searchTypeNameMap[this.searchTypeName],
          searchTypeName: this.searchTypeName
        },
        savedSearchJson: filter,
        createdTS: new Date(),
        updatedTS: new Date()
      }
      this.userService.addNewSavedSearch(savedSearchDto, username, this.impersonatedEmail).subscribe(
        (result: any) => {
          if (result && result.body) {
            this.currentSavedSearchDto = result.body;
            if (saveAndApplyFlag) {
              let expirationTimestamp: number = Date.now() + 1000*3600*2;
              localStorage.setItem('lastSearchGrantExpTime', expirationTimestamp.toString());
              localStorage.setItem('lastSearchGrant', this.currentSavedSearchDto.savedSearchJson);
              this.routerChild.navigateByUrl('app/search/grants');
            } else {
              this.routerChild.navigateByUrl('app/users/dashboard/saved-searches/all');
            }
          }
        }, (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          if (err.error && err.error.limitReached == "Y"
            && err.error.currentAmount == err.error.limitAmount) {
            this.pageErrorMessages.push({
              field: 'Saved Searches Limit Reached',
              detail: 'Woah, woah! You have reached your limit of ' + err.error.limitAmount +' saved searches. Consider deleting some saved searches.',
              severity: 'error'
            });
          } else {
            this.pageErrorMessages.push({
              field: 'Grant Saved Search API Failure',
              detail: 'Failed to create the saved search name: ' + savedSearchDto.savedSearchName,
              severity: 'error'
            });
          }
          this.showPageErrorMessagesToUser();
        }
      );

    } else if (browserUrl.includes('edit')) {
      const savedSearchDto: any = {
        savedSearchId: this.currentSavedSearchDto.savedSearchId,
        userId: this.currentSavedSearchDto.userId,
        savedSearchName: savedSearchName,
        searchTypeDto: {
          searchTypeId: this.searchTypeNameMap[this.searchTypeName],
          searchTypeName: this.searchTypeName
        },
        savedSearchJson: filter,
        createdTS: this.currentSavedSearchDto.createdTS,
        updatedTS: this.currentSavedSearchDto.updatedTS
      }
      this.userService.editSavedSearch(savedSearchDto, username, this.impersonatedEmail).subscribe(
        (result: any) => {
          if (result && result.body) {
            this.currentSavedSearchDto = result.body;
            if (saveAndApplyFlag) {
              let expirationTimestamp: number = Date.now() + 1000*3600*2;
              localStorage.setItem('lastSearchGrantExpTime', expirationTimestamp.toString());
              localStorage.setItem('lastSearchGrant', this.currentSavedSearchDto.savedSearchJson);
              this.routerChild.navigateByUrl('app/search/grants');
            } else {
              this.routerChild.navigateByUrl('app/users/dashboard/saved-searches/all');
            }
          }
        }, (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          this.pageErrorMessages.push({
            field: 'Grant Saved Search API Failure',
            detail: 'Failed to update the saved search name: ' + savedSearchDto.savedSearchName,
            severity: 'error'
          });
          this.showPageErrorMessagesToUser();
        }
      );
    } else {
      this.pageErrorMessages.push({
        field: 'Grant Saved Search UI Failure',
        detail: 'Unknown url logic error...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    }
  }

  private submitGrantSearch(saveAndApplyFlag: boolean): boolean {
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    //Build search dto from checkboxes
    let nonEmptyFilterFlag : boolean = false;
    this.savedGrantSearchName = '';
    const savedGrantSearchNameEl = document.getElementById('grant-search-filter-name-text-id');
    // @ts-ignore
    const nameSelected = savedGrantSearchNameEl.value;
    if (nameSelected) {
      this.savedGrantSearchName = nameSelected;
      nonEmptyFilterFlag = true;
    } else {
      this.pageErrorMessages.push({
        field: 'Grant Search Name Error',
        detail: 'The Grant Search Name is required and must not exceed 50 characters.',
        severity: 'error'
      });
    }


    this.grant_recipientNames = [];
    const recipientNamesEl = document.getElementById('grant-search-grant-names-text-id');
    // @ts-ignore
    const recipientNamesSelected = recipientNamesEl.value;
    if (recipientNamesSelected) {
      let cleanRecipientNames: string = this.apiService.trimLeadingTrailingSpaces(recipientNamesSelected);
      if (cleanRecipientNames.length > 200) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Grant Recipient characters limit exceeded. You are limited to 200 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      let recipientNamesFinal: string[] = cleanRecipientNames.split(",");
      if (recipientNamesFinal.length > 10) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Grant recipients limit exceeded. You are limited to 10 grant recipients.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < recipientNamesFinal.length; i = i + 1) {
        this.grant_recipientNames.push(this.apiService.trimLeadingTrailingSpaces(recipientNamesFinal[i]));
      }
      nonEmptyFilterFlag = true;
    }

    this.grant_cities = [];
    const citiesEl = document.getElementById('cities-text-id');
    // @ts-ignore
    const citiesSelected = citiesEl.value;
    if (citiesSelected) {
      let cleanCities: string = this.apiService.trimLeadingTrailingSpaces(citiesSelected);
      if (cleanCities.length > 200) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included cities characters limit exceeded. You are limited to 200 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      let citiesFinal: string[] = citiesSelected.split(",");
      if (citiesFinal.length > 10) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included cities limit exceeded. You are limited to 10 cities.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < citiesFinal.length; i = i + 1) {
        let finalCity = this.apiService.trimLeadingTrailingSpaces(citiesFinal[i])
        if (finalCity && !finalCity.startsWith(':')) {
          this.grant_cities.push(finalCity);
        }
      }
      nonEmptyFilterFlag = true;
    }

    this.grant_citiesWithout = [];
    /*
    const citiesWithoutEl = document.getElementById('cities-without-text-id');
    // @ts-ignore
    const citiesWithoutSelected = citiesWithoutEl.value;
    if (citiesWithoutSelected) {
      let cleanCitiesWithout: string = this.apiService.trimLeadingTrailingSpaces(citiesWithoutSelected);
      if (cleanCitiesWithout.length > 200) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Excluded cities characters limit exceeded. You are limited to 200 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      let citiesWithoutFinal: string[] = cleanCitiesWithout.split(",");
      if (citiesWithoutFinal.length > 10) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Excluded cities limit exceeded. You are limited to 10 cities.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i <citiesWithoutFinal.length; i = i + 1) {
        this.grant_citiesWithout.push(this.apiService.trimLeadingTrailingSpaces(citiesWithoutFinal[i]));
      }
      nonEmptyFilterFlag = true;
    }*/

    this.grant_states = [];
    const usaStateEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    const usaStateSelected = usaStateEl.value;
    if (usaStateSelected) {
      this.grant_states.push(usaStateSelected);
      nonEmptyFilterFlag = true;
    }

    this.grant_grantAmtMin = -1;
    const grantAmtMinEl = document.getElementById('grant-grant-amt-min-text-id');
    // @ts-ignore
    const grantAmtMinSelected = grantAmtMinEl.value;
    if (grantAmtMinSelected) {
      this.grant_grantAmtMin = parseInt(grantAmtMinSelected);
      nonEmptyFilterFlag = true;
    }

    this.grant_grantAmtMax = -1;
    const grantAmtMaxEl = document.getElementById('grant-grant-amt-max-text-id');
    // @ts-ignore
    const grantAmtMaxSelected = grantAmtMaxEl.value;
    if (grantAmtMaxSelected) {
      this.grant_grantAmtMax = parseInt(grantAmtMaxSelected);
      nonEmptyFilterFlag = true;
    }

    //Time Varying Parameters
    //Tax Year Filter
    this.grant_taxYear = this.grant_taxYearsRadioButtons[1].taxYear;
    for (const taxYearRadioButtonTemp of this.grant_taxYearsRadioButtons) {
      //At least one should always be checked by default
      if (taxYearRadioButtonTemp.checked === true) {
        this.grant_taxYear = taxYearRadioButtonTemp.taxYear;
        nonEmptyFilterFlag = true;
      }
    }

    if (this.grant_causeGivingInterestsList.length > 0) {
      if (this.grant_causeGivingInterestsList.length > 19) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included Cause Category Giving Interests limit exceeded. You are limited to 10 Cause Category Giving Interests.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      nonEmptyFilterFlag = true;
    }

    if (this.grant_causeGivingInterestsWithoutList.length > 0) {
      if (this.grant_causeGivingInterestsWithoutList.length > 10) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Excluded Cause Category Giving Interests limit exceeded. You are limited to 10 Cause Category Giving Interests.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
    }

    const browserUrl: string = window.location.href;

    if (this.grant_recipientNames.length == 0 && this.grant_cities.length == 0 && this.grant_citiesWithout.length == 0 && this.grant_states.length == 0 && this.grant_grantAmtMin == -1 && this.grant_grantAmtMax == -1 &&
      this.grant_cause.length == 0) {
      // Empty search query
      nonEmptyFilterFlag = false;
    }

    if ((!nameSelected || nameSelected.length > 50)) {
      this.showPageErrorMessagesToUser();
      return false;
    }

    this.sortByRecipientNameAscId = 0;
    if (this.recipientNameAscRadioButton) {
      this.sortByRecipientNameAscId = 1;
    } else if (this.recipientNameDescRadioButton) {
      this.sortByRecipientNameAscId = 2;
    }

    this.sortByCityAscId = 0;
    if (this.cityAscRadioButton) {
      this.sortByCityAscId = 1;
    } else if (this.cityDescRadioButton) {
      this.sortByCityAscId = 2;
    }

    this.sortByStateAscId = 0;
    if (this.stateAscRadioButton) {
      this.sortByStateAscId = 1;
    } else if (this.stateDescRadioButton) {
      this.sortByStateAscId = 2;
    }

    this.sortByGrantAmtAscId = 0;
    if (this.grantAmountAscRadioButton) {
      this.sortByGrantAmtAscId = 1;
    } else if (this.grantAmountDescRadioButton) {
      this.sortByGrantAmtAscId = 2;
    }

    if (!nonEmptyFilterFlag) {
      this.pageErrorMessages.push({
        field: 'Grant Search Filter Error',
        detail: 'Please submit a non empty filter.',
        severity: 'error'
      });
      return false;
    }

    const filter: SearchGrantsFilterDto = {
      'recipientNames': this.grant_recipientNames,
      'eins': this.grant_eins,
      'cities': this.grant_cities,
      'citiesWithout': this.grant_citiesWithout,
      'states': this.grant_states,
      'country': '',
      'grantAmtMin': this.grant_grantAmtMin,
      'grantAmtMax': this.grant_grantAmtMax,
      'taxYear': this.grant_taxYear,
      'causeGivingInterests': this.grant_causeGivingInterestsList,
      'causeGivingInterestsWithout': this.grant_causeGivingInterestsWithoutList,
      'sortByRecipientNameAsc': this.sortByRecipientNameAscId,
      'sortByCityAsc': this.sortByCityAscId,
      'sortByStateAsc': this.sortByStateAscId,
      'sortByGrantAmtAsc': this.sortByGrantAmtAscId
    }

    //Submit to API
    // @ts-ignore
    this.executeSearch(browserUrl, this.savedGrantSearchName, JSON.stringify(filter), this.username, saveAndApplyFlag);
    return true;
  }

  onSubmit(saveAndApplyFlag: boolean) {
    this.submitGrantSearch(saveAndApplyFlag);
  }

  openSearchTypeFilters(evt:any, searchTypeInput: string): void {
    this.searchTypeName = searchTypeInput;

    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      // @ts-ignore
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    // @ts-ignore
    document.getElementById(searchTypeInput).style.display = "block";
  }

  toggleRecipientNameAscButton(): void {
    this.recipientNameAscRadioButton = !this.recipientNameAscRadioButton;

    if (this.recipientNameAscRadioButton && this.recipientNameDescRadioButton) {
      this.recipientNameAscRadioButton = true;
      this.recipientNameDescRadioButton = false;
    }
  }

  toggleRecipientNameDescButton(): void {
    this.recipientNameDescRadioButton = !this.recipientNameDescRadioButton;
    if (this.recipientNameAscRadioButton && this.recipientNameDescRadioButton) {
      this.recipientNameAscRadioButton = false;
      this.recipientNameDescRadioButton = true;
    }
  }

  toggleCityAscButton(): void {
    this.cityAscRadioButton = !this.cityAscRadioButton;
    if (this.cityAscRadioButton && this.cityDescRadioButton) {
      this.cityAscRadioButton = true;
      this.cityDescRadioButton = false;
    }
  }

  toggleCityDescButton(): void {
    this.cityDescRadioButton = !this.cityDescRadioButton;
    if (this.cityAscRadioButton && this.cityDescRadioButton) {
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = true;
    }
  }

  toggleStateAscButton(): void {
    this.stateAscRadioButton = !this.stateAscRadioButton;
    if (this.stateAscRadioButton && this.stateDescRadioButton) {
      this.stateAscRadioButton = true;
      this.stateDescRadioButton = false;
    }
  }

  toggleStateDescButton(): void {
    this.stateDescRadioButton = !this.stateDescRadioButton;
    if (this.stateAscRadioButton && this.stateDescRadioButton) {
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = true;
    }
  }

  toggleGrantAmountAscButton(): void {
    this.grantAmountAscRadioButton = !this.grantAmountAscRadioButton;
    if (this.grantAmountAscRadioButton && this.grantAmountDescRadioButton) {
      this.grantAmountAscRadioButton = true;
      this.grantAmountDescRadioButton = false;
    }
  }

  toggleGrantAmountDescButton(): void {
    this.grantAmountDescRadioButton = !this.grantAmountDescRadioButton;
    if (this.grantAmountAscRadioButton && this.grantAmountDescRadioButton) {
      this.grantAmountAscRadioButton = false;
      this.grantAmountDescRadioButton = true;
    }
  }

  protected readonly event = event;
}
